import { useEffect } from 'react';

import type { BriefWizard } from '@/features/brief/model/BriefWizard';
import { useCosmos } from '@/features/cosmos/CosmosContext';

/**
 * Avancée du brief : le gaz se met à tourner dès la première étape, le nuage
 * s'effondre à chaque étape validée ; pendant l'envoi et une fois le brief
 * parti, l'étoile est au bout de sa formation.
 */
const momentumOf = (wizard: BriefWizard): number => {
  if (wizard.status === 'submitting' || wizard.status === 'sent') return 1;
  return 0.15 + ((wizard.stepNumber - 1) / Math.max(wizard.totalSteps - 1, 1)) * 0.65;
};

/**
 * La nébuleuse du brief suit le formulaire : chaque étape fait avancer la
 * formation de l'étoile, et le brief envoyé l'allume.
 */
export function useBriefCosmos(wizard: BriefWizard): void {
  const { controls } = useCosmos();
  const momentum = momentumOf(wizard);
  const sent = wizard.status === 'sent';

  useEffect(() => {
    controls?.setBriefMomentum(momentum);
  }, [controls, momentum]);

  useEffect(() => {
    if (sent) controls?.launch();
  }, [controls, sent]);
}
